import React, { useState } from 'react'
import { CustomCountryDropdown } from 'src/components/CountryFlagSelect';
import { useCampaignGenarationContext } from 'src/layouts/CampaignGenarionLayout';

export default function CustomNavRight() {
    const campaignContext = useCampaignGenarationContext()
    const { region, setRegion } = campaignContext || {}

    const handleSelectCountry = (country) => {
        if (setRegion) {
            setRegion(country)
        }
        window.location.reload();
    }

    return (
        <div className='campaign-custom-nav-right'>
            <CustomCountryDropdown className="nav-item" onSelect={handleSelectCountry} countryCode={region?.country_code} />
        </div>
    )
}
